import React, { useCallback } from 'react';
import { object } from 'prop-types';
import { Avatar, Button, NamedLink, ResponsiveImage } from '../../../components';

import { FormattedMessage, useIntl } from 'react-intl';

import get from 'lodash/get';
import { ensureTransaction } from '../../../util/data';
import { formatMoney } from '../../../util/currency';
import SummarySection from './SummarySection';
import TimelineSection from './TimelineSection';
import BondSection from './BondSection';

import css from './TransactionDetail.css';
import { useDispatch } from 'react-redux';
import { renewBond } from '../../TransactionPage/TransactionPage.duck';
import { BOND_FAIL_CREATED } from '../../../util/types';

const AVATAR_IMAGE_VARIANTS = [
  // 40x40
  'square-xsmall',

  // 80x80
  'square-xsmall2x',

  // 240x240
  'square-small',

  // 480x480
  'square-small2x',
];

const TransactionDetail = ({ item }) => {
  const intl = useIntl();
  const transaction = ensureTransaction(item);
  const { provider, customer, listing, id } = transaction;
  const transactionId = id.uuid;
  const listingId = listing && listing.id;
  const { title: lTitle, price: lPrice } = get(listing, 'attributes');
  const bondStatus = get(transaction, "attributes.metadata.bondStatus", null);
  const formattedPrice = formatMoney(intl, lPrice);
  const { displayName: cDisplayName } = get(customer, 'attributes.profile');
  const { displayName: pDisplayName } = get(provider, 'attributes.profile');
  const dispatch = useDispatch();
  const onRenewBond = useCallback(() => dispatch(renewBond({ transactionId })), [transactionId]);

  return (
    <div className={css.root}>
      <div className={css.contentContainer}>
        <div className={css.leftContent}>
          <div className={css.genralInfo}>
            <div className={css.stakeholder}>
              <ResponsiveImage
                rootClassName={css.thumbnailImage}
                alt={`listing ${listingId.uuid}`}
                image={listing.images[0]}
                variants={AVATAR_IMAGE_VARIANTS}
                sizes={'120px'}
              />
              <div className={css.userInfos}>
                <div className={css.userInfo}>
                  <Avatar className={css.avatar} user={customer} renderSizes="48px" />
                  <span className={css.displayName}>{cDisplayName}</span>
                  <span className={css.role}>
                    <FormattedMessage id="AMTxPage.customer" defaultMessage="customer" />
                  </span>
                </div>
                <div className={css.userInfo}>
                  <Avatar className={css.avatar} user={provider} renderSizes="48px" />
                  <span className={css.displayName}>{pDisplayName}</span>
                  <span className={css.role}>
                    <FormattedMessage id="AMTxPage.provider" defaultMessage="provider" />
                  </span>
                </div>
              </div>
            </div>
            <div className={css.listingInfo}>
              <NamedLink name="AdminPage" className={css.listingTitle}>
                {lTitle}
              </NamedLink>
              <div className={css.listingPrice}>{formattedPrice}</div>
            </div>
            <div className={css.review}>
              <NamedLink name="AdminPage" className={css.reviewLink}>
                <FormattedMessage id="AMTxPage.reviews" defaultMessage="Reviews" />
              </NamedLink>
              <span className={css.reviewCount}>0</span>
            </div>
            <div className={css.actionsWrapper}>
              {bondStatus === BOND_FAIL_CREATED &&
                <Button type="button" onClick={onRenewBond}>Retry bond</Button>
              }
            </div>
          </div>
        </div>
        <div className={css.rightContent}>
          <div className={css.rSection1}>
            <SummarySection transaction={transaction} />
            <TimelineSection transaction={transaction} />
          </div>
          <div className={css.rSection2}>
            <BondSection transaction={transaction} />
          </div>
        </div>
      </div>
    </div>
  );
};

TransactionDetail.propTypes = {
  item: object,
};

export default TransactionDetail;
